<template>
  <v-row no-gutters>
    <v-col cols="5" v-if="isFetched">
      <v-row no-gutters class="pt-10 pb-8">
        <base-button
          :disabled="$attrs.disabled"
          @click="addNewReport"
          translation-path="button.addReport"
          class="mr-0"
        ></base-button>
      </v-row>
      <v-row
        no-gutters
        class="border align-center element justify-space-between flex-nowrap px-4"
        style="background-color: white"
        v-for="report in customReports"
        :key="report.id"
      >
        <v-col cols="10">
          <div class="text-left text-truncate text-body-2 flex-shrink-0 py-2">
            {{ report.name }}
          </div>
        </v-col>
        <v-col cols="auto">
          <dots-menu
            font-size="19px"
            :items="dotsItems"
            @edit="openEditDialog(report)"
            @delete="openDeleteDialog(report)"
          >
          </dots-menu>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="5" v-else>
      <main-loader></main-loader>
    </v-col>
    <main-dialog
      v-if="isDeleteDialogLoaded"
      :is-visible.sync="isDeleteDialogVisible"
      :title="$i18n.t('admin.customReports.deleteReportTitle')"
      :body="$i18n.t('admin.customReports.deleteReportMessage', { name: deletingReport.name })"
      agree-text="dialog.agreeDelete"
      :loading="isDeleteLoading"
      @agree="handleDelete"
    />
    <zdm-reports-tab-custom-dialog
      v-if="isEditDialogLoaded"
      :is-visible.sync="isEditDialogVisible"
      :report-data.sync="currentReport"
    />
  </v-row>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
import { call, get } from 'vuex-pathify';
import MainLoader from '@/components/MainLoader';

export default {
  name: 'ZdmReportsTabCustom',
  components: {
    DotsMenu,
    MainLoader,
    MainDialog: () => import('@/components/MainDialog'),
    ZdmReportsTabCustomDialog: () => import('@/components/ZDMReportsTabCustomDialog'),
  },
  data: () => ({
    isFetched: false,
    isDeleteLoading: false,
    isDeleteDialogLoaded: false,
    isDeleteDialogVisible: false,
    isEditDialogLoaded: false,
    isEditDialogVisible: false,
    deletingReport: undefined,
    currentReport: undefined,
    dotsItems: [
      {
        name: 'edit',
      },
      {
        name: 'delete',
      },
    ],
  }),
  computed: {
    customReports: get('zdmCustomReports/reports'),
  },
  methods: {
    getCustomReports: call('zdmCustomReports/getCustomReports'),
    deleteCustomReport: call('zdmCustomReports/deleteCustomReport'),
    addNewReport() {
      this.currentReport = undefined;
      this.isEditDialogLoaded = true;
      this.isEditDialogVisible = true;
    },
    openEditDialog(report) {
      this.currentReport = report;
      this.isEditDialogLoaded = true;
      this.isEditDialogVisible = true;
    },
    openDeleteDialog(report) {
      this.deletingReport = report;
      this.isDeleteDialogLoaded = true;
      this.isDeleteDialogVisible = true;
    },
    async handleDelete() {
      this.isDeleteLoading = true;
      await this.deleteCustomReport(this.deletingReport.id);
      this.deletingReport = undefined;
      this.isDeleteLoading = false;
      this.isDeleteDialogLoaded = false;
      this.isDeleteDialogVisible = false;
    },
    async init() {
      await this.getCustomReports();
      this.isFetched = true;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.border {
  @include border(top);
  @include border(right);
  @include border(left);
  &:last-child {
    @include border(bottom);
  }
}
</style>
